<script>
  import Emitter from 'theme/mixins/emitter';

  export default {
    name: 'ZkRadioGroup',

    componentName: 'radio-group',

    mixins: [Emitter],

    props: {
      value: [String, Number],
      size: String
    },
    watch: {
      value(value) {
        this.$emit('change', value);
        this.dispatch('form-item', 'zk.form.change', [this.value]);
      }
    }
  };
</script>

<template>
  <div class="zk-radio-group">
    <slot></slot>
  </div>
</template>



// WEBPACK FOOTER //
// radio-group.vue?0e53d868